import { partition } from 'lodash';

import { Medium } from '@/models/medium';

import { FileWithMediumId } from './useFileUploader';

type LoadingImageAndFileUploads = {
  loadingUploads: FileWithMediumId[];
  loadingImageUploads: FileWithMediumId[];
  loadingFileUploads: FileWithMediumId[];
};

/**
 *
 * @param loadingUploads All files in loading state.
 * @returns Only files for which the medium hasn't been created yet. Also, it separates images and files.
 */
export const extractLoadingImageAndFileUploads = (
  loadingOrSucceededUploads: FileWithMediumId[],
  media: Medium[]
): LoadingImageAndFileUploads => {
  const loadingUploads = filterOutSuccessfullyUploaded(loadingOrSucceededUploads, media);

  return separateFilesAndImages(loadingUploads);
};

const filterOutSuccessfullyUploaded = (
  loadingOrSucceededUploads: FileWithMediumId[],
  media: Medium[]
): FileWithMediumId[] => {
  return loadingOrSucceededUploads.filter(
    (loadingOrSucceededUpload) =>
      !media.find((medium) => medium.id === loadingOrSucceededUpload.mediumId)
  );
};

const separateFilesAndImages = (loadingUploads: FileWithMediumId[]): LoadingImageAndFileUploads => {
  const [loadingImageUploads, loadingFileUploads] = partition(loadingUploads, (loadingUpload) =>
    loadingUpload.file.type.startsWith('image/')
  );

  return {
    loadingUploads,
    loadingImageUploads,
    loadingFileUploads,
  };
};
